module.exports = __webpack_public_path__ + "static/media/shop_open.94565218.png";